import { useEffect } from "react";

export const Loader = (props) => {

    const show = () => {
        document.getElementById("preloader").style.display = "block"
        document.getElementById("status").style.display = "block"
    }

    const hide = () => {
        document.getElementById("preloader").style.display = "none"
        document.getElementById("status").style.display = "none"
        window.scrollTo(0, 0)
    }

    useEffect(() => {
        if (props.showLoader) {
            show();
        } else {
            hide();
        }
    }, [props.showLoader])

    return (
        <div id="preloader">
            <div id="status">
                <div className="spinner-chase">
                    <div className="chase-dot"></div>
                    <div className="chase-dot"></div>
                    <div className="chase-dot"></div>
                    <div className="chase-dot"></div>
                    <div className="chase-dot"></div>
                    <div className="chase-dot"></div>
                </div>
            </div>
        </div>
    )

}


